import React from 'react'

import PropTypes from 'prop-types'

import { Typography } from '@mui/material'

import { InfoTileCard, InfoTileCardContent } from '../../styles/components/InfoTileStyle'

const InfoTile = ({ title, value }) => {
  return (
    <InfoTileCard elevation={3}>
      <InfoTileCardContent>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
        <Typography variant="h3" component="p">
          {value}
        </Typography>
      </InfoTileCardContent>
    </InfoTileCard>
  )
}

InfoTile.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
}

export default InfoTile
